import React from 'react'
import { CardWithIcon, IProps as ICard } from 'marketing-site/src/library/elements/CardWithIcon'
import {
  ICardWithIcon as IContentfulCardWithIcon,
  ICtaButton as IContentfulCtaButton,
} from 'marketing-site/@types/generated/contentful'
import { ICtaLink as IContentfulCtaLink } from 'marketing-site/@types/generated/contentful'
import { transformCTAWithBackground } from './ContentfulCTALink'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { CTALink } from '../../library/elements/CTALink'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { transformImage } from './ContentfulImage'

type ICTA = IContentfulCtaLink | IContentfulCtaButton | undefined

function renderGenericCTA(cta: ICTA) {
  if (cta) {
    return <CTALink {...transformCTAWithBackground(cta as IContentfulCtaLink)} />
  }
}

export const ContentfulCardWithIcon = (card: IContentfulCardWithIcon): React.ReactElement => (
  <EntryMarker entry={card}>{() => <CardWithIcon {...transformCardWithIcon(card)} />}</EntryMarker>
)

export function transformCardWithIcon({ fields }: IContentfulCardWithIcon): ICard {
  return {
    ...fields,
    title: fields.titleText && documentToHtmlString(fields.titleText),
    icon: transformImage(fields.icon),
    body: fields.body,
    cta: fields.cta && (() => renderGenericCTA(fields.cta)),
  }
}
